import styled from 'styled-components'

interface IContainerProps {
  width?: 'large' | 'small' | 'medium' | 'mediumSmall'
  disabled?: boolean
}

const widthMap = {
  large: '408px',
  medium: '325px',
  mediumSmall: '296px',
  small: '180px',
} as const

export const Container = styled.div<IContainerProps>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  height: 48px;
  padding: 10px 8px;
  gap: 4px;
  border-radius: 5px;
  border: 1px solid
    ${({ disabled }) =>
      disabled ? '#CCCCCC' : 'var(--preto-principal, #1c1d22)'};
  overflow: hidden;
  ${({ width }) => width && `width: ${widthMap[width]};`}
  .sb-img {
    width: 16px;
    height: 16px;
    ${({ disabled }) => disabled && `opacity: 0.3;`}
  }
  .clear-btn {
    position: absolute;
    top: 50%;
    right: 7px;
    transform: translateY(-50%);
    padding: 5px;
    border: none;
    background: none;
    transition: opacity 0.2s;
    cursor: pointer;
  }
  .clear-btn:hover {
    opacity: 0.6;
  }
  .clear-icon {
    width: 10px;
    height: 10px;
  }
`

export const SearchBar = styled.input`
  transition: width 1s;
  width: 100%;
  outline: none;
  border: none;
  background-image: none;
  background-color: transparent;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  box-sizing: border-box;
  color: #d4d4d4;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  ::placeholder {
    font-size: 12px;
    color: #757575;
  }
  &:disabled {
    opacity: 0.5;
  }
  @media only screen and (min-width: 1441px) {
    font-size: 13px;
    ::placeholder {
      font-size: 13px;
    }
  }
`
